module.exports = __webpack_public_path__ + "img/5_37.625a4b18.png";